class Slider{
  constructor(setting) {
    if(setting === undefined) {
      setting = {
        wrapper: '.slider__wrapper',
        slide: '.slide',
        btnNext: '.slide__btn-next',
        btnPrev: '.slide__btn-prev',
        infinite: false,
        disableBtnClass: 'slide__btn--disabled',
      };
    }

    this.wrap = $(setting.wrapper).addClass('slider__wrapper');
    this.slide = $(setting.slide).addClass('slide');
    this.slideBtnNext = $(setting.btnNext).addClass('slide__btn slide__btn-next');
    this.slideBtnPrev = $(setting.btnPrev).addClass('slide__btn slide__btn-prev');
    this.disableBtnClass = setting.disableBtnClass;
    this.infinite = setting.infinite;

    if(!this.infinite) {
      this.slide.each((index, item) => {
        const target = $(item);
        target.find(this.slideBtnPrev).removeClass(this.disableBtnClass + ` ` + ` ` + 'slide__btn--disabled');
        target.find(this.slideBtnNext).removeClass(this.disableBtnClass + ` ` + ` ` + 'slide__btn--disabled');
        if (index === 0) {
          target.find(this.slideBtnPrev).addClass(this.disableBtnClass + ` ` + ` ` + 'slide__btn--disabled')
        }
        if (index === this.slide.length - 1) {
          target.find(this.slideBtnNext).addClass(this.disableBtnClass + ` ` + ` ` + 'slide__btn--disabled')
        }
      });
    }

    if(this.slide.length === 1){
      this.slideBtnNext.css('display', 'none');
      this.slideBtnPrev.css('display', 'none');
    } else {
      this.slideBtnNext.css('display', 'flex');
      this.slideBtnPrev.css('display', 'flex');
    }

    this.init(this.wrap, this.slide);
  }

  init(wrap, slide){
    this.slideBtnNext.off().on('click', function () {
      wrap.children(slide).first().fadeOut(200, () => {
        wrap.children(slide).first().appendTo(wrap).addClass('slide-down').removeClass('slide-up').hide();
      }).fadeIn(400);
    });

    this.slideBtnPrev.off().on('click', function() {
      wrap.children(slide).last().fadeOut(100, () => {
        wrap.children(slide).last().prependTo(wrap).addClass('slide-up').removeClass('slide-down').hide();
      }).fadeIn(400);
    });
  }

  destroySlider(){
    this.slideBtnNext.off().removeClass('slide__btn-next');
    this.slideBtnPrev.off().removeClass('slide__btn-prev');
    this.wrap.removeClass('slider__wrapper');
    this.slide.removeClass('slide');
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/slider/index.js